(function () {

  'use strict';

  eclipseApp.directive('prepaidUsageDial', function () {
    return {
        restrict: 'E',
      scope: true,
      replace: true,
      templateUrl: 'modules/core/views/prepaid-usage-dial.html'

    };
  });

})();

